import { PerformanceStore, useCurrentWorkspace, useIsCurrentUserAdmin } from 'src/store';
import { createStateSelectorHook } from 'src/lib/sweetState';
import { RESOURCE_CONTENT_TYPE } from 'src/data/performance';

const usePerformanceState = createStateSelectorHook(PerformanceStore, ['resources']);

export const useResources = ({
  shouldGetAllResources = false,
  shouldGetOnlyAssociated = false,
} = {}) => {
  const currentWorkspace = useCurrentWorkspace();
  const isCurrentUserAdmin = useIsCurrentUserAdmin();
  const { resources } = usePerformanceState();

  let alignedResources = resources;

  if ((!isCurrentUserAdmin && !shouldGetAllResources) || shouldGetOnlyAssociated) {
    alignedResources = currentWorkspace?.associatedResources;
  }

  return alignedResources;
};

export const useUrlResources = () => {
  const currentWorkspace = useCurrentWorkspace();

  return (
    currentWorkspace?.associatedResources?.filter(
      (r) => r.contentType === RESOURCE_CONTENT_TYPE.url
    ) || []
  );
};

export const useImageResources = () => {
  const currentWorkspace = useCurrentWorkspace();

  return (
    currentWorkspace?.associatedResources?.filter(
      (r) => r.contentType === RESOURCE_CONTENT_TYPE.img
    ) || []
  );
};

export const useDocumentResources = () => {
  const currentWorkspace = useCurrentWorkspace();

  return (
    currentWorkspace?.associatedResources?.filter(
      (r) => r.contentType === RESOURCE_CONTENT_TYPE.document
    ) || []
  );
};
